import { Injectable } from '@angular/core';
import { LevelNameService } from 'src/app/authentication/otp/level-name.service';

@Injectable({
  providedIn: 'root'
})
export class ChurchNamingService {
  constructor(private levelNameService: LevelNameService) {}

  private normalize(value?: string | null): string {
    return (value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  getChurchName(): string {
    return this.levelNameService.getLevelNames()?.churchName || '';
  }

  isRomanCatholic(): boolean {
    return this.normalize(this.getChurchName()).includes('roman catholic');
  }

  getServiceLabel(): string {
    return this.isRomanCatholic() ? 'Mass or Service' : 'Service';
  }

  getServicesLabel(): string {
    return this.isRomanCatholic() ? 'Masses or Services' : 'Services';
  }

  getManageServicesLabel(): string {
    return this.isRomanCatholic() ? 'Manage Masses or Services' : 'Manage Services';
  }

  getCreateServiceLabel(): string {
    return this.isRomanCatholic() ? 'Create Mass or Service' : 'Create Service';
  }

  getAddServiceLabel(): string {
    return this.isRomanCatholic() ? 'Add Mass or Service' : 'Add Service';
  }

  getRegularServicesLabel(): string {
    return this.isRomanCatholic() ? 'Regular Masses or Services' : 'Regular Services';
  }

  getAddRegularServiceLabel(): string {
    return this.isRomanCatholic() ? 'Add Regular Mass or Service' : 'Add Regular Service';
  }

  getEditRegularServiceLabel(): string {
    return this.isRomanCatholic() ? 'Edit Regular Mass or Service' : 'Edit Regular Service';
  }

  getServicePresiderNameLabel(): string {
    return this.isRomanCatholic() ? 'Mass or Service Presider Name' : 'Service Presider Name';
  }

  getServicePresiderLabel(): string {
    return this.isRomanCatholic() ? 'Mass or Service Presider' : 'Service Presider';
  }

  getServiceTypeLabel(): string {
    return this.isRomanCatholic() ? 'Mass or Service Type' : 'Service Type';
  }

  getSearchServicesPlaceholder(): string {
    return this.isRomanCatholic() ? 'Search masses or services...' : 'Search services...';
  }
}
